<div class="w-100-p" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource" matSort matSortActive="{{ sortBy }}" matSortDirection="{{ sortOrder }}" class="mat-elevation-z0">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? toggle.emit(isAllSelected) : null"
                    [checked]="selectedUserIds.length && isAllSelected"
                    [indeterminate]="selectedUserIds.length && !isAllSelected"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let audienceUser">
                <mat-checkbox [(ngModel)]="checkboxes[audienceUser.id]" (ngModelChange)="select.emit(audienceUser)" (click)="$event.stopPropagation()"> </mat-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let audienceUser">
                <div class="relative" #avatarCell>
                    <img class="avatar pointer" *ngIf="audienceUser.user?.avatar.src; else initials" [alt]="audienceUser.user?.fullName" [src]="audienceUser.user?.avatar.src" />
                    <ng-template #initials>
                        <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ audienceUser.user?.fullName | initials }}</div>
                    </ng-template>
                    <ng-template [onlineStateIndicator]="audienceUser.user?.isOnline"> </ng-template>
                </div>
            </mat-cell>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let audienceUser">
                <a *ngIf="audienceUser.user" class="text-truncate font-semibold" [routerLink]="['/users/' + audienceUser.user.id + '/edit']">{{ audienceUser.user.firstName }}</a>
            </mat-cell>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.LAST_NAME' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let audienceUser">
                <a *ngIf="audienceUser.user" class="text-truncate font-semibold" [routerLink]="['/users/' + audienceUser.user.id + '/edit']">{{ audienceUser.user.lastName }}</a>
            </mat-cell>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm> {{ 'GENERAL.PROPERTY.EMAIL' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let audienceUser" fxHide fxShow.gt-sm>
                <a *ngIf="audienceUser.user" [href]="'mailto:' + audienceUser.user.email" target="_top">{{ audienceUser.user.email }}</a>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let audienceUser; let i = index">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>
                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <button
                            mat-menu-item
                            (click)="openPasswordlessAccessDialog(audienceUser)"
                            [disabled]="audienceUser.user?.status !== 'active'"
                            *ngIf="actionPermissions.canCreatePasswordless && actionPermissions.isPasswordlessLoginFeatureEnabled"
                        >
                            <mat-icon svgIcon="qr_code" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.CREATE_PASSWORDLESS_ACCESS' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="openAssignUserToTeamDialog(audienceUser)" *ngIf="actionPermissions.canAssignTeam">
                            <mat-icon svgIcon="team" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.ASSIGN_TO_TEAM' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToExperience(audienceUser)" *ngIf="actionPermissions.canAssignExperience">
                            <mat-icon svgIcon="assign_user_to_experience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_EXPERIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToAudience(audienceUser)" *ngIf="actionPermissions.canAssignAudience">
                            <mat-icon svgIcon="assign_user_to_audience" class="mr-8"></mat-icon>
                            <span>{{ 'GENERAL.BUTTON.ASSIGN_TO_AUDIENCE' | translate }}</span>
                        </button>

                        <button mat-menu-item (click)="assignUserToCourse(audienceUser)" *ngIf="actionPermissions.canAssignCourse">
                            <mat-icon class="mr-8">school</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.TAKE_OVER' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            (click)="resetPassword(audienceUser)"
                            *ngIf="actionPermissions.canResetPassword && !actionPermissions.isSSOFeatureEnabled"
                        >
                            <mat-icon svgIcon="lock_reset" class="mr-8"></mat-icon>
                            <span>{{ 'USER.BUTTON.RESET_PASSWORDS' | translate: { total: 1 } }}</span>
                        </button>

                        <app-menu-item-button
                            aria-label="move"
                            [icon]="'drive_file_move'"
                            [label]="'GENERAL.BUTTON.MOVE_TO'"
                            (onClick)="moveMember(audienceUser.id)"
                            [showThreeDots]="true"
                        ></app-menu-item-button>

                        <button mat-menu-item (click)="deleteAudienceUser(audienceUser)" *ngIf="actionPermissions.canRemove">
                            <mat-icon class="mr-8">delete</mat-icon>
                            <span>{{ 'GENERAL.BUTTON.REMOVE' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let audienceUser; columns: displayedColumns" class="user" [ngClass]="{ 'accent-50': checkboxes[audienceUser.id] }" matRipple> </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="grow.audience-users-list" [length]="totalCount$ | async" [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
</div>
